import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal"},[_c('div',{staticClass:"d-flex align-center"},[_c('search-component'),_c(VBtn,{staticClass:"pr-2",attrs:{"icon":"","small":""},on:{"click":_vm.close}},[_c(VIcon,{staticClass:"ml-2"},[_vm._v("mdi-close")])],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }